<template>
    <div class="flex-row align-items-center" v-loading="loading"
      :element-loading-text="'Please wait...'"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">

  
      <div class="container">

        <br><br>


        <b-row class="">

            <b-col md="10" sm="10">
                <b-card no-body class="mx-4">
                <b-card-body class="p-4">
                    <h1>Choose a Package</h1>
                    <p class="text-muted
                    ">Select a package that suits your business needs and proceed to registration</p>
                </b-card-body>
                </b-card>
            </b-col>

        </b-row>
  
  
        <b-row class="justify-content-center">
  
          
  
          <b-col md="6" v-for="item in packages" key="item.id">
            <b-card>
                <template slot="header">
                  <h4>{{item.title}} USD {{item.package_price_usd}} per month</h4>
                </template>
  
                <ul style="list-style: none;">
  
                    <li>{{item.package_features.sites}} Storefronts</li>
                    <li>{{item.package_features.mailboxes}} Business Email Domains</li>
                    <li>{{item.package_features.newsletters}} Business Newsletters</li>
                    <li>{{item.package_features.workspaces}} Business Automation Workspaces</li>
                   
                    <li>{{item.package_features.monthly_autoposts>1000?'Unlimited': item.package_features.monthly_autoposts}} Monthly Social Media Posts</li>
                   
                    <li > 
                        <i v-if="item.package_features.facebook" class="fa fa-check"></i> 
                        <i v-if="!item.package_features.facebook" class="fa fa-times"></i>

                        Facebook & Instagram Integration
                        
                    </li>
                    <li>
                        <i v-if="item.package_features.tiktok" class="fa fa-check"></i> 
                        <i v-if="!item.package_features.tiktok" class="fa fa-times"></i>
                        TikTok Integration</li>
                    <li> 
                        <i v-if="item.package_features.twitter" class="fa fa-check"></i> 
                        <i v-if="!item.package_features.twitter" class="fa fa-times"></i>
                        Twitter Integration</li>
                    <li> 
                        <i v-if="item.package_features.pinterest" class="fa fa-check"></i> 
                        <i v-if="!item.package_features.pinterest" class="fa fa-times"></i>

                        Pinterest Integration</li>
                    <li> 
                        <i  class="fa fa-check"></i> 
                        Payments Integration</li>
                   
                </ul>
  
                <template slot="footer">
                  <b-button @click="choosePackage(item.id)" variant="primary"  style="width: 100%;">Get Started</b-button>
                </template>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </template>
  
  <script>
  import { getTableData} from '../../services/v1/api_store'
  import {DEFAULT_TOAST} from '../../services/v1/constants';
  
  const opts =  DEFAULT_TOAST;
  
  export default {
    name: 'Account',
  
    mounted () {
  
        let self = this;
  
        getTableData(this.$store, `users/packages/list`, text => self.handleDataLoaded(text));
    },
    methods: {
        handleDataLoaded (resp) {
          console.log(resp);
          this.packages = resp.response.packages;
          this.loading = false;
        }, 
  
        choosePackage(packageid) {
          this.$router.push({path: '/register', query: {package: packageid}})
        }
    },
    data () {
      return {
        isTrial: false,
        loading: true,
        packages: []
      }
    },
  }
  </script>